import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CASAVI_CONTACT_BLACKLIST_UPDATE_RESOURCE = "casavi-contact-blacklist" as const;
export const CASAVI_CONTACT_BLACKLIST_UPDATE_API_PATH =
  `/v1/${CASAVI_CONTACT_BLACKLIST_UPDATE_RESOURCE}/{uuid}` as const;

export type CasaviContactBlacklistUpdateBody =
  paths[typeof CASAVI_CONTACT_BLACKLIST_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type CasaviContactBlacklistUpdateResponse =
  paths[typeof CASAVI_CONTACT_BLACKLIST_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useCasaviContactBlacklistUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CasaviContactBlacklistUpdateResponse, Error, CasaviContactBlacklistUpdateBody & { uuid: string }>({
    mutationFn: async (casaviContactBlacklist: CasaviContactBlacklistUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = casaviContactBlacklist;
      const response = await alphartisApiAxios.patch<CasaviContactBlacklistUpdateResponse>(
        `/v1/${CASAVI_CONTACT_BLACKLIST_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CASAVI_CONTACT_BLACKLIST_UPDATE_RESOURCE],
      });
    },
  });
};
